jQuery( document ).ready(
	// TODO: remember to delete this async once done
	function ($) {
		//console.log("LOADED");
		// Add js body class when javascript is enabled
		jQuery('body').addClass('js');

		/*
		* Force full-width videos. Relies upon the FitVids library
		*/
		jQuery('.entry').fitVids();

		assignLuminosityToSiteHeaderBasedOnBackground( 150)

		// Done with CSS
		// jQuery( "#top_search" ).hide();
	}
);
